// *
// * Constants.js
// * This is the constants file.
// *
// *

module.exports = {
  POKEMON_BASE_API: "https://pokeapi.co/api/v2/pokemon/?limit=",
  POKEMON_IMAGE_URL: "https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/",
  POKEMON_TYPES: ["grass", "fire", "electric", "ground", "rock", "fairy", "water", "flying", "bug", "poison", "fighting", "psychic", "steel", "ice", "ghost", "dragon"]
}